import {
  createGoldBotResourceReader,
  isPlainObject,
} from "./goldBotResource";

export const getGoldBotPerformance = createGoldBotResourceReader({
  path: "/performance",
  label: "performance",
  isValidPayload: (payload) =>
    isPlainObject(payload) &&
    typeof payload.available === "boolean" &&
    Array.isArray(payload.equity_curve),
});
